import React from "react";
import { Grid, Paper } from "@mui/material";
import AnalyticsPie from "../DataComponents/AnalyticsPie";
import AnalyticsDashboard from "../DataComponents/AnalyticsDashboard";

interface AnalyticsBAProps {
  salesOverviewData: Array<{
    label: string;
    value: number | string;
  }>;
  analyticsData: Array<{
    id: string;
    value: number;
    label: string;
  }>;
}

const AnalyticsBA: React.FC<AnalyticsBAProps> = ({
  salesOverviewData,
  analyticsData,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper elevation={3}>
          <AnalyticsDashboard
            data={salesOverviewData}
            title="Performance Metrics"
          />
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper elevation={3}>
          <AnalyticsPie data={analyticsData} title="Sales by Category" />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AnalyticsBA;
